import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UrlService {
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private location: Location
    ) {}
    addQueryParam(key, value) {
        const param = {};
        param[key] = value;
        const url = this.router
            .createUrlTree([], {
                queryParams: param,
                relativeTo: this.route,
                queryParamsHandling: 'merge',
            })
            .toString();

        this.location.go(url);
    }
    removeParamsFromUrl(): Observable<boolean> {
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: null,
        });
        setTimeout(() => {
            return of(true);
        });

        return of(false);
    }
}
